import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

export interface PageTabItem {
  label: React.ReactNode;
  content: React.ReactNode;
}

export function PageTabs({
  tabs,
  index,
  onChange,
  width = '100%',
  maxW = '100%',
}: {
  tabs: PageTabItem[];
  index: number;
  onChange: (index: number) => void;
  width?: string;
  maxW?: string;
}) {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box width={width} maxW={maxW} padding={4}>
      <Tabs
        index={index}
        onChange={onChange}
        variant="enclosed"
        colorScheme="blue"
        bg={bgColor}
        borderRadius="lg"
        boxShadow="lg"
        border="1px solid"
        borderColor={borderColor}
      >
        <TabList borderBottom="1px solid" borderColor={borderColor} bg="gray.50" borderTopRadius="lg">
          {tabs.map((tab, i) => (
            <Tab
              key={i}
              _selected={{
                color: 'blue.600',
                bg: 'white',
                borderColor: borderColor,
                borderBottomColor: 'white',
                mb: '-1px',
              }}
              fontWeight="semibold"
              fontSize="xs"
              px={4}
              py={2.5}
              gap={2}
              display="flex"
              alignItems="center"
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>

        <TabPanels>
          {tabs.map((tab, i) => (
            <TabPanel key={i} p={0}>
              {tab.content}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
}
